import { type DataThemeOptions } from '@saviynt/design-system';

import { type GLOBAL_ALERT_BANNER_TYPES } from '../constants';

// Global types
export enum GlobalType {
  SLICE_NAME = 'savicopilot/globalSlice',
  EP_SLICE_NAME = 'savicopilot/globalEpSlice',
}

export interface AlertBannerState {
  kind: (typeof GLOBAL_ALERT_BANNER_TYPES)[keyof typeof GLOBAL_ALERT_BANNER_TYPES];
  title: string;
  description: string;
  link?: {
    text: string;
    onClick: (props: unknown) => void | undefined | null;
    suffixIcon: string;
  };
  isOpen: boolean;
  dataTheme: DataThemeOptions;
}

export interface GlobalState {
  dataTheme: DataThemeOptions;
  globalDateFormat: string;
  isGlobalLoading: boolean;
  isGlobalError: boolean;
  globalErrorReason: string;
  mediaQueryValue: number;
  alertBanner: AlertBannerState;
}
